import { render, staticRenderFns } from "./AreaTreeSelect.vue?vue&type=template&id=58d0690e&scoped=true"
import script from "./AreaTreeSelect.vue?vue&type=script&lang=ts"
export * from "./AreaTreeSelect.vue?vue&type=script&lang=ts"
import style0 from "./AreaTreeSelect.vue?vue&type=style&index=0&id=58d0690e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d0690e",
  null
  
)

export default component.exports